module.exports = __webpack_public_path__ + "static/media/diners.1c83d7ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/credit_cards/diners.svg
// module id = 168
// module chunks = 0